/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminPhoneNumberCreateDTO } from '../models';
// @ts-ignore
import type { AdminPhoneNumberResponseDTO } from '../models';
// @ts-ignore
import type { AdminPhoneNumberUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageAdminPhoneNumberResponseDTO } from '../models';
/**
 * AdminPhoneNumbersApi - axios parameter creator
 * @export
 */
export const AdminPhoneNumbersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminPhoneNumberApiV1AdminPhoneNumbersPost: async (adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPhoneNumberCreateDTO' is not null or undefined
            assertParamExists('createAdminPhoneNumberApiV1AdminPhoneNumbersPost', 'adminPhoneNumberCreateDTO', adminPhoneNumberCreateDTO)
            const localVarPath = `/api/v1/admin/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPhoneNumberCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1: async (adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPhoneNumberCreateDTO' is not null or undefined
            assertParamExists('createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1', 'adminPhoneNumberCreateDTO', adminPhoneNumberCreateDTO)
            const localVarPath = `/api/v1/admin/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPhoneNumberCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/admin/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2: async (phoneNumberId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2', 'phoneNumberId', phoneNumberId)
            const localVarPath = `/api/v1/admin/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminPhoneNumbersApiV1AdminPhoneNumbersGet: async (organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (unassignedOnly !== undefined) {
                localVarQueryParameter['unassigned_only'] = unassignedOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3: async (organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/phone-numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (unassignedOnly !== undefined) {
                localVarQueryParameter['unassigned_only'] = unassignedOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch: async (phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch', 'phoneNumberId', phoneNumberId)
            // verify required parameter 'adminPhoneNumberUpdateDTO' is not null or undefined
            assertParamExists('updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch', 'adminPhoneNumberUpdateDTO', adminPhoneNumberUpdateDTO)
            const localVarPath = `/api/v1/admin/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPhoneNumberUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4: async (phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberId' is not null or undefined
            assertParamExists('updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4', 'phoneNumberId', phoneNumberId)
            // verify required parameter 'adminPhoneNumberUpdateDTO' is not null or undefined
            assertParamExists('updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4', 'adminPhoneNumberUpdateDTO', adminPhoneNumberUpdateDTO)
            const localVarPath = `/api/v1/admin/phone-numbers/{phone_number_id}`
                .replace(`{${"phone_number_id"}}`, encodeURIComponent(String(phoneNumberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPhoneNumberUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPhoneNumbersApi - functional programming interface
 * @export
 */
export const AdminPhoneNumbersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPhoneNumbersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.createAdminPhoneNumberApiV1AdminPhoneNumbersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId, unassignedOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId, unassignedOnly, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPhoneNumberResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPhoneNumbersApi.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPhoneNumbersApi - factory interface
 * @export
 */
export const AdminPhoneNumbersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPhoneNumbersApiFp(configuration)
    return {
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminPhoneNumberResponseDTO> {
            return localVarFp.createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a phone number in an explicit organization.
         * @summary Create Admin Phone Number
         * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminPhoneNumberResponseDTO> {
            return localVarFp.createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a phone number and clear any linked agent assignment.
         * @summary Delete Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAdminPhoneNumberResponseDTO> {
            return localVarFp.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId, unassignedOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List phone numbers across organizations with optional filters.
         * @summary List Admin Phone Numbers
         * @param {string | null} [organizationId] 
         * @param {boolean} [unassignedOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAdminPhoneNumberResponseDTO> {
            return localVarFp.listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId, unassignedOnly, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminPhoneNumberResponseDTO> {
            return localVarFp.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a phone number and its organization assignment.
         * @summary Update Admin Phone Number
         * @param {string} phoneNumberId 
         * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminPhoneNumberResponseDTO> {
            return localVarFp.updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPhoneNumbersApi - object-oriented interface
 * @export
 * @class AdminPhoneNumbersApi
 * @extends {BaseAPI}
 */
export class AdminPhoneNumbersApi extends BaseAPI {
    /**
     * Create a phone number in an explicit organization.
     * @summary Create Admin Phone Number
     * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).createAdminPhoneNumberApiV1AdminPhoneNumbersPost(adminPhoneNumberCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a phone number in an explicit organization.
     * @summary Create Admin Phone Number
     * @param {AdminPhoneNumberCreateDTO} adminPhoneNumberCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO: AdminPhoneNumberCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).createAdminPhoneNumberApiV1AdminPhoneNumbersPost_1(adminPhoneNumberCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a phone number and clear any linked agent assignment.
     * @summary Delete Admin Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a phone number and clear any linked agent assignment.
     * @summary Delete Admin Phone Number
     * @param {string} phoneNumberId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).deleteAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdDelete_2(phoneNumberId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List phone numbers across organizations with optional filters.
     * @summary List Admin Phone Numbers
     * @param {string | null} [organizationId] 
     * @param {boolean} [unassignedOnly] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).listAdminPhoneNumbersApiV1AdminPhoneNumbersGet(organizationId, unassignedOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List phone numbers across organizations with optional filters.
     * @summary List Admin Phone Numbers
     * @param {string | null} [organizationId] 
     * @param {boolean} [unassignedOnly] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId?: string | null, unassignedOnly?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).listAdminPhoneNumbersApiV1AdminPhoneNumbersGet_3(organizationId, unassignedOnly, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a phone number and its organization assignment.
     * @summary Update Admin Phone Number
     * @param {string} phoneNumberId 
     * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a phone number and its organization assignment.
     * @summary Update Admin Phone Number
     * @param {string} phoneNumberId 
     * @param {AdminPhoneNumberUpdateDTO} adminPhoneNumberUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPhoneNumbersApi
     */
    public updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId: string, adminPhoneNumberUpdateDTO: AdminPhoneNumberUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminPhoneNumbersApiFp(this.configuration).updateAdminPhoneNumberApiV1AdminPhoneNumbersPhoneNumberIdPatch_4(phoneNumberId, adminPhoneNumberUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

